import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import BarChartIcon from '@mui/icons-material/BarChart';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import useAuth from '../../hooks/useAuth';

const navItems = [
  { label: 'Patientes', icon: <PeopleIcon />, path: '/' },
  { label: 'Rapport', icon: <DescriptionIcon />, path: '/per-mutuelle-v2' },
  { label: 'Stats', icon: <BarChartIcon />, path: '/stats', adminOnly: true },
  { label: 'Admin', icon: <AdminPanelSettingsIcon />, path: '/admin', adminOnly: true },
  { label: 'Profil', icon: <PersonIcon />, path: '/profile' }
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = useAuth();
  const isAdmin = email === 'imad@benim.be';

  const visibleItems = navItems.filter((item) => !item.adminOnly || isAdmin);

  // Find current path index, handle nested routes
  const currentIndex = visibleItems.findIndex((item) => {
    if (item.path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(item.path);
  });

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        pb: 'env(safe-area-inset-bottom)',
        display: { lg: 'none' } // Hide on desktop
      }}
      elevation={8}
    >
      <BottomNavigation
        value={currentIndex >= 0 ? currentIndex : false}
        onChange={(e, newValue) => navigate(visibleItems[newValue].path)}
        showLabels
        sx={{
          minHeight: 56,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            py: 1,
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main'
            }
          }
        }}
      >
        {visibleItems.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
            aria-label={item.label}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
